var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InformeCard',{attrs:{"title":"Gráfico desglosado del total de recaudación"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('GChart',{staticStyle:{"width":"100%","height":"300px"},attrs:{"type":"PieChart","data":_vm.chartData,"options":_vm.chartOptions}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }